import React, { useState, useEffect, useRef } from "react";
// import Breadcrumbs from "../../core/breadcrumbs";
import { Filter } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { Archive, Calendar, User } from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import StockTransferModal from "../../core/modals/stocks/stocktransferModal";
import Table from "../../core/pagination/datatable";
import { useDispatch, useSelector } from "react-redux";
import {
  API_BASE_URL,
  GET_TRANSFER_STOCK,
  GET_TRANSFER_STOCK_PDF,
} from "../../Config";
import Axios from "axios";
import { settransferstock_data } from "../../core/redux/action";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import IndentStockTransferModal from "../../core/modals/stocks/indentstocktransfer";
import UploadFiles from "../UploadFiles";
import { getUserPermissions } from "../../UserPermissions";

import html2pdf from "html2pdf.js";
// import ReactToPrint from "react-to-print";
// import PrintLogoImg from './41115.png';
import SpinLoader from "../loader/SpinLoader";

const StockTransfer = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [editTransferObj, setEditTransferObj] = useState([]);
  const [stockTRPdf, setStockTRPdf] = useState([]);
  const [uploadTransferObj, setUploadTransferObj] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalReqQty, setTotalReqQty] = useState(0);
  const [totalTransferQty, setTotalTransferQty] = useState(0);

  // ✅ FIX: "isVisible1" was used in JSX below but never declared anywhere in
  // the original file, so page-wrapper was permanently getting
  // `display: none` (referencing an undefined variable). The page-wrapper
  // should just always render — it isn't the same thing as the hidden
  // print/download node, so there's no need for a visibility flag here at all.

  // Separate trigger flags — print and download run independent effects off
  // the same fetched data, so they never step on each other.
  const [isPrintTriggered, setIsPrintTriggered] = useState(false);
  const [isDownloadTriggered, setIsDownloadTriggered] = useState(false);

  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.transferstock_data) || [];

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}&StoreId=0`,
      )
        .then((response) => {
          if (response.data.Status) {
            dispatch(settransferstock_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Transfer");
    setPermissions(perms);
  }, []);

  const filteredData = dataSource.filter(
    (item) =>
      (item &&
        item.ToStore &&
        item.ToStore.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.FromStore &&
        item.FromStore.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.IndentNo &&
        item.IndentNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.TransferOrder &&
        item.TransferOrder.toString().includes(searchQuery.toLowerCase())),
  );

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const warehouseOptions = [
    { value: "Lobar Handy", label: "Lobar Handy" },
    { value: "Quaint Warehouse", label: "Quaint Warehouse" },
    { value: "Traditional Warehouse", label: "Traditional Warehouse" },
    { value: "Cool Warehouse", label: "Cool Warehouse" },
  ];

  const destinationOptions = [
    { value: "Selosy", label: "Selosy" },
    { value: "Logerro", label: "Logerro" },
    { value: "Vesloo", label: "Vesloo" },
    { value: "Crompy", label: "Crompy" },
  ];

  const columns = [
    {
      title: "Order No",
      dataIndex: "AutoGenTransactionNo",
      sorter: (a, b) =>
        a.AutoGenTransactionNo.length - b.AutoGenTransactionNo.length,
      render: (text, record) => `ST-${record.AutoGenTransactionNo}`,
    },
    {
      title: "Date",
      dataIndex: "TransferDate",
      sorter: (a, b) => new Date(a.TransferDate) - new Date(b.TransferDate),
      render: (TransferDate) => {
        const date = new Date(TransferDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Indent No",
      dataIndex: "IndentNo",
      sorter: (a, b) => a.IndentNo.length - b.IndentNo.length,
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "From Store",
      dataIndex: "FromStore",
      sorter: (a, b) => a.FromStore.length - b.FromStore.length,
      render: (text) => (
        <span
          title={text}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "To Store",
      dataIndex: "ToStore",
      sorter: (a, b) => a.ToStore.length - b.ToStore.length,
      render: (text) => (
        <span
          title={text}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      sorter: (a, b) => a.Status - b.Status,
      render: (status) => {
        let statusText;
        let className = "badge ";

        switch (status) {
          case "Pending":
            statusText = "Pending";
            className += "bg-outline-warning";
            break;
          case "RECEIVED":
            statusText = "Received";
            className += "bg-outline-success";
            break;
          case "DRAFT":
            statusText = "Draft";
            className += "bg-outline-warning";
            break;
          case "TRANSFERED":
            statusText = "Transfered";
            className += "bg-outline-info";
            break;
          default:
            statusText = status;
            className += "badge-default";
            break;
        }

        return <span className={className}>{statusText}</span>;
      },
    },
    {
      title: "Req Qty",
      dataIndex: "TotalReqQuantity",
      sorter: (a, b) => a.TotalReqQuantity.length - b.TotalReqQuantity.length,
    },
    {
      title: "Trf Qty",
      dataIndex: "TotalTransferQty",
      sorter: (a, b) => a.TotalTransferQty.length - b.TotalTransferQty.length,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        const uploadType =
          record.Status === "TRANSFERED"
            ? "StockTransfered"
            : record.Status === "RECEIVED"
              ? "StockReceived"
              : null;

        return (
          <td>
            <div className="edit-delete-action">
              <Link to="#" className="dropdown-toggl" data-bs-toggle="dropdown">
                <i className="fa-solid fa-ellipsis-vertical btn border"></i>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className="dropdown-item my-3 ms-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewStockTrnsf"
                  aria-controls="offcanvasRightViewStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-regular fa-eye me-2"></i>
                  View
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    record.Status === "TRANSFERED" ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightEditStockTrnsf"
                  aria-controls="offcanvasRightEditStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-regular fa-pen-to-square me-2"></i>
                  Edit
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3`}
                  onClick={() => downloadPDF(record.TransferId)}
                >
                  <i className="fa-regular fa-file-pdf me-2"></i>
                  Download Pdf
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3`}
                  onClick={() => printRecord(record.TransferId)}
                >
                  <i className="fa-solid fa-print me-2"></i>
                  Print
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    record.Status === "TRANSFERED" ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightRecStockTrnsf"
                  aria-controls="offcanvasRightRecStockTrnsf"
                  onClick={() => showEditModal(record)}
                >
                  <i className="fa-solid fa-download me-2"></i>
                  Receive Stock
                </Link>

                <Link
                  to="#"
                  className={`dropdown-item ms-3 my-3 ${
                    uploadType ? "" : "disabled"
                  }`}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightUploadFiles"
                  aria-controls="offcanvasRightUploadFiles"
                  onClick={() => {
                    if (uploadType) {
                      showUploadFilesModal(record, uploadType);
                    }
                  }}
                >
                  <i className="fa-solid fa-cloud-arrow-up me-2"></i>
                  Upload Files
                </Link>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const showEditModal = (TransferObj) => {
    setEditTransferObj(TransferObj);
  };

  const showUploadFilesModal = (transferObj, uploadType) => {
    setUploadTransferObj(transferObj.TransferId);
    setUploadType(uploadType);
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setProperties({
      title: " stockTransfer",
      author: "Your Name",
      creator: "Your Application",
    });

    const tableData = [];
    const headers = [
      "Transfer Order",
      "Transfer Date",
      "From Store",
      "To Store",
      "Status",
    ];
    tableData.push(headers);

    filteredData.forEach((item) => {
      const row = [];
      row.push(
        `ST${item.AutoGenTransactionNo}`,
        formatDate(item.TransferDate),
        item.FromStore,
        item.ToStore,
        item.Status,
      );
      tableData.push(row);
    });

    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    doc.save("stockTransfer.pdf");
  };

  const generateEXCEL = () => {
    if (filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const headers = [
      "Transfer Order",
      "Transfer Date",
      "From Store",
      "To Store",
      "Status",
    ];

    const wsData = filteredData.map((item) => ({
      "Transfer Order": `ST${item.AutoGenTransactionNo}`,
      "Transfer Date": formatDate(item.TransferDate),
      "From Store": item.FromStore,
      "To Store": item.ToStore,
      Status: item.Status,
    }));

    wsData.unshift({
      "Transfer Order": headers[0],
      "Transfer Date": headers[1],
      "From Store": headers[2],
      "To Store": headers[3],
      Status: headers[4],
    });

    const ws = XLSX.utils.json_to_sheet(wsData, { skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, "StockTransferData");
    XLSX.writeFile(wb, "StockTransfer.xlsx");
  };

  const handleReload = () => {
    window.location.reload();
  };

  const printRef = useRef();

  useEffect(() => {
    let totalTransfQty = 0;
    let totalReqqty = 0;

    if (stockTRPdf && stockTRPdf.length > 0) {
      totalReqqty = stockTRPdf.reduce((acc, product) => {
        const amount = product.ReqQuantity;
        return acc + (amount || 0);
      }, 0);

      totalTransfQty = stockTRPdf.reduce((acc, product) => {
        const amount = product.TransferQty;
        return acc + (amount || 0);
      }, 0);
    }

    setTotalTransferQty(totalTransfQty);
    setTotalReqQty(totalReqqty);
  }, [stockTRPdf]);

  // ---- OLD APPROACHES (kept for reference, do not use) ----
  // const printRecord = async (id) => {
  //   try {
  //     const response = await Axios.get(
  //       `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`
  //     );
  //     if (response.data.Status) {
  //       setStockTRPdf(response.data.ResultData);
  //       setTimeout(() => {
  //         window.print();
  //       }, 500);
  //     } else {
  //       console.error("Error fetching data:", response.data.Message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message || error);
  //   }
  // };
  //
  // This version worked most of the time but was a race: setTimeout(500ms)
  // has no guarantee the state update + re-render had actually landed in the
  // DOM by then (slow devices / big payloads would print blank/stale data).
  // That's why it moved to the effect-based version below, which prints only
  // once stockTRPdf has actually changed and the DOM has painted.
  // -----------------------------------------------------------

  // ✅ PRINT — opens the native print preview/dialog (matches your requirement
  // that Print should show the preview, not silently save a file).
  const printRecord = async (id) => {
    try {
      const response = await Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`,
      );

      if (response.data.Status) {
        setStockTRPdf(response.data.ResultData);
        setIsPrintTriggered(true);
      } else {
        console.error("Error fetching data:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    }
  };

  // ✅ DOWNLOAD — saves a PDF file directly, no dialog. Uses html2pdf.js
  // (html2canvas + jsPDF under the hood) against the exact same printRef
  // node, so the download looks identical to the print preview.
  const downloadPDF = async (id) => {
    try {
      const response = await Axios.get(
        `${API_BASE_URL}${GET_TRANSFER_STOCK_PDF}?OrgId=${userDataSession.OrgId}&TransactionId=${id}`,
      );

      if (response.data.Status) {
        setStockTRPdf(response.data.ResultData);
        setIsDownloadTriggered(true);
      } else {
        console.error("Error fetching data:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    }
  };

  // ✅ PRINT EFFECT — fires only after stockTRPdf has actually updated.
  useEffect(() => {
    if (!isPrintTriggered || !stockTRPdf?.length) {
      return;
    }

    const printContents = printRef.current?.innerHTML;

    if (!printContents) {
      console.error("Print content not found");
      setIsPrintTriggered(false);
      return;
    }

    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      console.error("Unable to open print window");
      setIsPrintTriggered(false);
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Stock Transfer</title>
          <style>
            * { box-sizing: border-box; }

            /* ✅ PADDING FIX: page margin is 0 here on purpose. The print
               path and the download path (html2pdf) are two completely
               different rendering engines, and each honours "page margin"
               differently — that mismatch is why padding looked fine in
               one and vanished in the other. Instead, the padding lives on
               #print-wrapper itself (a real CSS property on the actual
               content box), so both paths render the exact same spacing. */
            @page {
              size: A4;
              margin: 0;
            }

            body {
              font-family: 'Segoe UI', Arial, sans-serif;
              margin: 0;
              padding: 0;
              color: #33404f;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              font-size: 10.5px;
            }

            /* ✅ THE FOOTER FIX:
               #print-wrapper is a flex column that is at least one full
               page tall. The final child uses margin-top:auto, which
               pushes it down to consume all remaining space instead of
               sitting flush under the content above it. */
            #print-wrapper {
              display: flex;
              flex-direction: column;
              min-height: 100vh;
              padding: 0.5in;
              box-sizing: border-box;
            }

            #print-footer {
              margin-top: auto;
              padding-top: 8px;
              border-top: 1px solid #1f3a5f;
              text-align: center;
            }

            @media print {
              body { margin: 0; }
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };

    // Close the popup once the print dialog itself is dismissed (works in
    // Chrome/Edge; browsers that block onafterprint on the child window will
    // just leave the tab open, which is harmless).
    printWindow.onafterprint = () => {
      printWindow.close();
    };

    setIsPrintTriggered(false);
  }, [stockTRPdf, isPrintTriggered]);

  // ✅ DOWNLOAD EFFECT — fires only after stockTRPdf has actually updated,
  // renders printRef straight to a saved .pdf, no popup/dialog involved.
  useEffect(() => {
    if (!isDownloadTriggered || !stockTRPdf?.length) {
      return;
    }

    const element = printRef.current;

    if (!element) {
      console.error("Print content not found");
      setIsDownloadTriggered(false);
      return;
    }

    const fileName = `StockTransfer-ST-${
      stockTRPdf?.[0]?.AutoGenTransactionNo || "transfer"
    }.pdf`;

    const options = {
      // margin: 0 on purpose — the 0.5in padding is already baked into
      // #print-wrapper's own inline style, so this stays 0 to avoid
      // doubling up the whitespace around the page.
      margin: 0,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .set(options)
      .from(element)
      .save()
      .then(() => {
        setIsDownloadTriggered(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setIsDownloadTriggered(false);
      });
  }, [stockTRPdf, isDownloadTriggered]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* /Stock transfer list */}
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Transfer List</h4>
                <h6>Manage your Transfers</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={generateEXCEL}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="d-flex">
              <div className="d-flex purchase-pg-btn me-2">
                <div className="page-btn">
                  <Link
                    to="#"
                    className={`btn btn-added ${permissions.isRead}`}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightAddStockTrnsf"
                    aria-controls="offcanvasRightAddStockTrnsf"
                  >
                    <PlusCircle className="me-2" />
                    By Product
                  </Link>
                </div>
              </div>
              <div className="d-flex purchase-pg-btn">
                <div className="page-btn">
                  <Link
                    to="#"
                    className={`btn btn-added ${permissions.isRead}`}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightIndentAddStockTrnsf"
                    aria-controls="offcanvasRightIndentAddStockTrnsf"
                  >
                    <PlusCircle className="me-2" />
                    By Indent
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? "" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "none" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Archive className="info-img" />
                        <Select
                          className="select"
                          options={warehouseOptions}
                          placeholder="Warehouse From"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="select"
                          options={destinationOptions}
                          placeholder="Warehouse To"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Calendar className="info-img" />
                        <div className="input-groupicon">
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Choose Date"
                            className="datetimepicker"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                      <div className="input-blocks">
                        <a className="btn btn-filters ms-auto">
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                {loading ? (
                  <SpinLoader />
                ) : (
                  <Table
                    className="table datanew"
                    columns={columns}
                    dataSource={filteredData}
                  />
                )}
              </div>
            </div>
          </div>
          {/* /Stock transfer list */}
        </div>

        <StockTransferModal transferObj={editTransferObj} />
        <IndentStockTransferModal transferObj={editTransferObj} />
        <UploadFiles number={uploadTransferObj} type={uploadType} />
      </div>

      <div
        ref={printRef}
        className="pdf-document"
        style={{
          position: "absolute",
          top: 0,
          left: "-10000px",
          width: "794px",
          fontFamily: "'Segoe UI', Arial, sans-serif",
          color: "#33404f",
          background: "#ffffff",
        }}
      >
        <div
          id="print-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "1050px", // approx one A4 page at this width
            padding: "0.5in",
            boxSizing: "border-box",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              borderBottom: "3px solid #1f3a5f",
              paddingBottom: "8px",
              marginBottom: "16px",
            }}
          >
            <div style={{ flex: 1 }}>
              <h4
                style={{
                  margin: "2px 0 0 0",
                  color: "#1f3a5f",
                  fontWeight: 700,
                }}
              >
                ST-{stockTRPdf?.[0]?.AutoGenTransactionNo || ""}
              </h4>
            </div>

            <div style={{ flex: 1, textAlign: "center" }}>
              <h4
                style={{
                  margin: 0,
                  color: "#1f3a5f",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                }}
              >
                Stock Transfer
              </h4>
            </div>

            <div style={{ flex: 1, textAlign: "right" }}>
              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#33404f",
                }}
              >
                Date - {formatDate(stockTRPdf?.[0]?.TransferDate)}
              </p>
            </div>
          </div>

          {/* From / To store cards */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "16px",
              marginBottom: "18px",
            }}
          >
            {[
              {
                label: "To Store",
                name: stockTRPdf?.[0]?.ToStore,
                phone: stockTRPdf?.[0]?.ToStPhone,
                email: stockTRPdf?.[0]?.ToStEmail,
                city: stockTRPdf?.[0]?.ToStCity,
                state: stockTRPdf?.[0]?.ToStState,
                address: stockTRPdf?.[0]?.ToStAddress,
              },
              {
                label: "From Store",
                name: stockTRPdf?.[0]?.FromStore,
                phone: stockTRPdf?.[0]?.FrStPhone,
                email: stockTRPdf?.[0]?.FrStEmail,
                city: stockTRPdf?.[0]?.FrStCity,
                state: stockTRPdf?.[0]?.FrStState,
                address: stockTRPdf?.[0]?.FrStAddress,
              },
            ].map((store, i) => (
              <div
                key={i}
                style={{
                  width: "48%",
                  border: "1px solid #d7dce3",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#1f3a5f",
                    color: "#ffffff",
                    fontSize: "10px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    padding: "5px 10px",
                  }}
                >
                  {store.label}
                </div>
                <div
                  style={{
                    padding: "8px 10px",
                    fontSize: "10px",
                    lineHeight: "1.6",
                  }}
                >
                  <p style={{ margin: 0, fontWeight: 600, color: "#1f3a5f" }}>
                    {store.name || ""}
                  </p>
                  <p style={{ margin: 0 }}> Phone: {store.phone || "-"}</p>
                  <p style={{ margin: 0 }}> Email: {store.email || "-"}</p>
                  <p style={{ margin: 0 }}>
                    {store.city || ""}
                    {store.city && store.state ? ", " : ""}
                    {store.state || ""}
                  </p>
                  <p style={{ margin: 0 }}>{store.address || ""}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Items table */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "14px",
            }}
          >
            <thead>
              <tr>
                {["#", "Item", "Request Qty", "Transfer Qty"].map((h, i) => (
                  <th
                    key={i}
                    style={{
                      border: "1px solid #1f3a5f",
                      padding: "6px 8px",
                      textAlign: i >= 2 ? "right" : "left",
                      backgroundColor: "#1f3a5f",
                      color: "#ffffff",
                      fontSize: "10.5px",
                      fontWeight: 600,
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stockTRPdf?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f7fa",
                  }}
                >
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      color: "#1f3a5f",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      color: "#1f3a5f",
                    }}
                  >
                    {item.ProductName}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      textAlign: "right",
                      color: "#1f3a5f",
                    }}
                  >
                    {item.ReqQuantity}
                  </td>
                  <td
                    style={{
                      border: "1px solid #d7dce3",
                      padding: "5px 8px",
                      fontSize: "10px",
                      textAlign: "right",
                      color: "#1f3a5f",
                    }}
                  >
                    {item.TransferQty}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  colSpan="2"
                  style={{
                    border: "1px solid #1f3a5f",
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "right",
                    backgroundColor: "#eef1f5",
                    fontSize: "10.5px",
                    color: "#1f3a5f",
                  }}
                >
                  Total:
                </td>
                <td
                  style={{
                    border: "1px solid #1f3a5f",
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "right",
                    backgroundColor: "#eef1f5",
                    fontSize: "10.5px",
                  }}
                >
                  {totalReqQty}
                </td>
                <td
                  style={{
                    border: "1px solid #1f3a5f",
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "right",
                    backgroundColor: "#eef1f5",
                    fontSize: "10.5px",
                  }}
                >
                  {totalTransferQty}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Tracking details */}
          {stockTRPdf?.[0]?.TrackingDetails && (
            <div
              style={{
                backgroundColor: "#f5f7fa",
                border: "1px solid #d7dce3",
                borderRadius: "4px",
                padding: "6px 10px",
                fontSize: "9.5px",
                marginBottom: "14px",
              }}
            >
              <strong style={{ color: "#1f3a5f" }}>Tracking Details: </strong>
              {stockTRPdf?.[0]?.TrackingDetails}
            </div>
          )}

          <div
            style={{
              borderLeft: "3px solid #1f3a5f",
              backgroundColor: "#fafbfc",
              padding: "8px 12px",
              marginBottom: "16px",
            }}
          >
            <p
              style={{
                margin: "0 0 4px 0",
                fontSize: "9.5px",
                fontWeight: 700,
                color: "#1f3a5f",
              }}
            >
              Comments / Special Instructions
            </p>
            <p
              style={{ margin: "0 0 2px 0", fontSize: "9px", color: "#4a5568" }}
            >
              • Please verify the quantities upon receipt.
            </p>
            <p
              style={{ margin: "0 0 2px 0", fontSize: "9px", color: "#4a5568" }}
            >
              • Notify us immediately if there are any discrepancies or damages.
            </p>
            <p
              style={{ margin: "0 0 6px 0", fontSize: "9px", color: "#4a5568" }}
            >
              • Ensure all items are stored as per the guidelines to maintain
              quality.
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "9.5px",
                fontWeight: 600,
                textAlign: "center",
                color: "#1f3a5f",
              }}
            >
              Thank you for your business.
            </p>
          </div>

          <div id="print-footer">
            <p
              style={{
                margin: 0,
                fontSize: "8.5px",
                color: "#000000",
                letterSpacing: "0.3px",
              }}
            >
              Powered by PerennialCode
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockTransfer;
